import BooleanFieldInternal, { componentName } from './BooleanFieldInternal';

customElements.define(componentName, BooleanFieldInternal);
